import { render, staticRenderFns } from "./SkeletonLoaderCheckboxes.vue?vue&type=template&id=1a33d181&"
import script from "./SkeletonLoaderCheckboxes.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoaderCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
